import { render, staticRenderFns } from "./image.vue.js?vue&type=template&id=ce9c5b3e&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image.vue?vue&type=template&id=ce9c5b3e&vue3"
import script from "./image.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image.vue?vue&type=script&lang=js&vue3"
export * from "./image.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports